import React from 'react';
import '../../styles/enterprise.css';

/**
 * Single KPI card: uppercase label, big tabular value, delta chip, gray sub-line.
 *
 * <KpiCard
 *   label="TOTAL VOLUME (7D)"
 *   value="$8,420.18"
 *   delta={{ value: '+18.2%', direction: 'up' }}   // 'up' | 'down' | 'neutral'
 *   sub="47 transactions"
 * />
 *
 * Pass delta={null} or omit it to render no chip. Use direction 'neutral'
 * (value defaults to "—") when a metric has no comparison data.
 */
const KpiCard = ({ label, value, delta, sub }) => {
  const dir = delta?.direction || 'neutral';
  const chipClass = dir === 'up' ? 'pos' : dir === 'down' ? 'neg' : 'neutral';
  const chipText = delta ? (delta.value ?? '—') : null;

  return (
    <div className="kpi-card">
      <span className="kpi-card__label">{label}</span>
      <div className="kpi-card__valrow">
        <span className="kpi-card__value">{value}</span>
        {/* {chipText !== null ? (
          <span className={`delta-chip ${chipClass}`}>{chipText}</span>
        ) : null} */}
      </div>
      {sub ? <span className="kpi-card__sub">{sub}</span> : null}
    </div>
  );
};

export default KpiCard;
